import * as React from 'react';
import { Link } from '../../../common/Link';
import { IPaymentStatusProps } from './types';
import * as styles from './PaymentStatus.css';
import successIcon from './assets/success.svg';
import failIcon from './assets/fail.svg';
import { useDeviceCondition } from '../../../../hooks';
import classNames from 'classnames';
import { InlineText1, InlineText2, Spinner } from '@cian/ui-kit';

export const PaymentStatus = (props: IPaymentStatusProps) => {
  const { status, handleRetryClick } = props;

  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);
  const InlineText = useDeviceCondition(InlineText2, InlineText1);

  return (
    <div className={classNames(styles['wrapper'], rootStyle)}>
      {status === 'pending' && (
        <>
          <Spinner size={16} />
          <div className={styles['text']}>
            <InlineText>Выполнение платежа</InlineText>
          </div>
        </>
      )}

      {status === 'succeeded' && (
        <>
          <img src={successIcon} className={styles['icon']} data-mark="icon|success" />
          <div className={styles['text']}>
            <InlineText>Платёж успешно выполнен</InlineText>
          </div>
        </>
      )}

      {status === 'canceled' && (
        <>
          <img src={failIcon} className={styles['icon']} data-mark="icon|fail" />
          <div className={styles['text']}>
            <InlineText>
              Не удалось выполнить платёж. <Link onClick={handleRetryClick}>Повторить</Link>
            </InlineText>
          </div>
        </>
      )}
    </div>
  );
};
